/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @deprecated
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['underscore', 'jquery', 'backbone', 'assets/js/modules/screen', 'jquery-ui/jquery-ui'], function(_, $, backbone, screen) {
    var Popup = function($el, options) {
        _.extend(this, backbone.Events);
        var _this = this;
        this.$el = $el;

        options = options || {};
        _.defaults(options, this.defaultOptions);

        // width should not extend the screen width
        var maxWidth = screen.getWidth() - 20;
        if (options.width && options.width > maxWidth) {
            options.width = maxWidth;
        }

        // extend `open` callback to close popup on outside click
        var openCallback = options.open;
        options.open = function() {
            $('.ui-widget-overlay').on('click', function() {
                _this.$el.dialog('close');
            });
            if (_.isFunction(openCallback)) {
                openCallback();
            }
        };

        this.$el.dialog(options);

        // traverse events
        this.$el.on('dialogopen', function() {
            _this.trigger('open');
        });

        this.$el.on('dialogclose', function() {
            _this.trigger('close');
        });

        if (options.removeAfterClose === true) {
            this.$el.on('dialogclose', function() {
                _this.destroy();
            });
        }
    };

    Popup.prototype = {
        defaultOptions: {
            autoOpen: false,
            resizable: false,
            modal: true
        },

        open: function() {
            this.$el.dialog('open');
            this.$el.scrollTop(0);
        },

        close: function() {
            this.$el.dialog('close');
        },

        destroy: function() {
            if (this.$el.dialog('instance') !== undefined) {
                this.$el.dialog('destroy');
            }
            this.$el.remove();
        },

        /**
         * @param {string} content
         */
        setContent: function(content) {
            this.$el.html(content);
            this.trigger('contentUpdated');
        },

        /**
         * @param {string} title
         */
        setTitle: function(title) {
            this.$el.dialog({ title: title });
        },

        /**
         * @param {string} name
         * @param {*} value
         */
        setOption: function(name, value) {
            this.$el.dialog('option', name, value);
        }
    };

    return Popup;
});
